import { save, embedRasterImages } from 'd3-save-svg';
import * as d3 from "d3";
import { cloneDeep } from 'lodash'

function exportSVG() {
  console.log('export')

  // stop the transitions and set the opacity right
  d3.selectAll('img').interrupt('fade');
  d3.selectAll('img').attr('opacity', 1);
  // d3.selectAll('circle').attr('opacity', Math.ceil(1));

  var today = new Date();
  var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

  const config = {
    filename: 'Droogteketen-' + date,
  }
  const svg = d3.select('svg')

  const svg_export = svg.node().cloneNode(true)

  save(svg_export, config);

}

export default exportSVG;
